module.exports = __webpack_public_path__ + "static/media/plus.c217bfb1.svg";